import React, { useContext } from "react";
import "../../pages/LoginPage/styles/styles.css";
import "../../styles/global.css";
import { images } from "../../constants";
import { TranslationsContext } from "../../utils/TranslationsContext";
import { handleLogout } from "../../utils/methods";
import ChangePassword from "../Modal/components/Profile/components/ChangePassword";

// Full-screen gate shown by ProtectedRoute while the account still has an
// admin-assigned password. No way past it except changing it or logging out;
// gs.be refuses every other operation for this user until then.
const ForcePasswordChange = ({ onDone }) => {
  const { t } = useContext(TranslationsContext);

  return (
    <div className="flex-direction-column gap-24 items-center justify-center login-container">
      <div className="flex-direction-column gap-8 items-center">
        <img src={images.logo} alt="logo" className="flag" />
        <h1 className="font-36 inria-sans-300 login-title">
          {t("ACCREDITATION_TITLE")}
        </h1>
        <p className="font-16 inria-sans-300 login-subtitle">
          {t("FORCE_PASSWORD_CHANGE_NOTICE")}
        </p>
      </div>
      <div className="flex-direction-column gap-12 login-form">
        <ChangePassword t={t} onSuccess={onDone} />
        <p
          className="font-14 inria-sans-300 login-forgot-pass"
          onClick={handleLogout}
        >
          {t("LOGOUT")}
        </p>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
